import { InjectionToken } from '@angular/core';
import { ExtraOptions } from './types';

export const NGX_ROUTE_OPTIONS = new InjectionToken<ExtraOptions>('NGX_ROUTE_QUERY_NAME');
